import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { tablerTrophy } from '@ng-icons/tabler-icons';

@Component({
  selector: 'oc-no-items',
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerTrophy,
    }),
  ],
  template: `<div class="oc-no-items">
    <ng-icon *ngIf="icon" [name]="icon" size="100" color="#ccc" class="mb-3"></ng-icon>
    <h2>{{ mainTitle }}</h2>
    <p *ngIf="subTitle">{{ subTitle }}</p>
  </div>`,
  styles: `
    .oc-no-items {
      height: calc(100vh - 300px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    h2 {
      font-weight: 400;
      color: #ccc;
      margin: 0;
      margin-bottom: 4px;
    }

    p {
      color: #ccc;
      margin: 0;
    }
  `,
})
export class NoItemsComponent {
  @Input() mainTitle = 'No Items';
  @Input() subTitle = 'No items yet!';
  @Input() icon: string | null = null;
}
